import { http } from '@/http';

export default {
    state: {
        page: 1,
        pagesCount: 0,
        posts: [],
        postsCount: 0
    },
    getters: {
        page(state) {
            return state.page;
        },
        pagesCount(state) {
            return state.pagesCount;
        },
        posts(state) {
            return state.posts;
        },
        postsCount(state) {
            return state.postsCount;
        }
    },
    mutations: {
        SET_PAGE(state, payload) {
            state.page = payload;
        },
        SET_PAGES_COUNT(state, payload) {
            state.pagesCount = payload;
        },
        SET_POSTS(state, payload) {
            state.posts = payload;
        },
        SET_POSTS_COUNT(state, payload) {
            state.postsCount = payload;
        }
    },
    actions: {
        fetchPost(_, payload) {
            let mode = payload.mode || "edit";
            return http.get(`/active-trader/posts/${payload.id}`, {
                params: {
                    mode
                }
            }).then(res => res.data).catch(err => {
                console.error(err.message);
                throw err;
            });
        },
        fetchPosts({ commit }, payload) {
            return http.get("/active-trader/posts", {
                params: payload
            })
                .then(res => {
                    commit("SET_POSTS", res.data.posts);
                    commit("SET_POSTS_COUNT", res.data.posts_count);
                    commit("SET_PAGES_COUNT", res.data.pages_count);
                    return res.data;
                })
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        insertPost(_, payload) {
            return http.post("/active-trader/posts", payload)
                .then(res => res.data)
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        updatePost(_, payload) {
            return http.put(`/active-trader/posts/${payload.id}`, payload)
                .then(res => res.data)
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        deletePost(_, payload) {
            return http.delete(`/active-trader/posts/${payload.id}`)
                .then(res => res.data)
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        setPage({ commit }, payload) {
            commit("SET_PAGE", payload);
        },
    }
};
